<template>
  <p class="title" :style="{ marginTop: (isPC ? '30px' : '80px') }">{{title}}</p>
</template>

<script>
  import translate from '../common/Translate.js'
  import { checkDevice, getInviteTitle } from '../common/Common.js'
  export default {
    // props: {
    //   title: String
    // },
    data () {
      return {
        isPC: checkDevice(),
        title: ''
      }
    },
    updated () {
      // this.init()
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        if (this.$route.path === '/invite/invitenext') {
          if (this.$route.query['fromwebsite']) {
            this.title = translate('newInviteTitle7', this.$route.query['name'])
          } else {
            this.title = translate('newInviteTitle4', this.$route.query['name'])
          }
        } else {
          this.title = await getInviteTitle(this)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .title {
    width: 300px;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    margin: 35px auto;
  }
</style>



// WEBPACK FOOTER //
// Title.vue?3ff87a6e